import {Component, OnDestroy, OnInit} from '@angular/core';
import {UserAccessPermissions} from "../../../entities/UserAccessPermissions";
import {DetailUserAccessPermissions} from "../../../entities/DetailUserAccessPermissions";
import {SecurityService} from "../../../services/security.service";
import {FunctionType} from "../../../enum/functionType";
import {MenuService} from "../../../services/menu-service";
import {Subscription} from "rxjs/internal/Subscription";
import {UtilityService} from "../../../services/utility.service";
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-gestione-utenti',
    templateUrl: './gestione-utenti.component.html',
    styleUrls: ['./gestione-utenti.component.css'],
    standalone: false
})
export class GestioneUtentiComponent implements OnInit, OnDestroy {

  private loadingSub: Subscription | undefined;

  isLoadingStaticData = true;
  isLoading = false;
  isFirsttime = true;
  isDetailVisible = false;

  userAccessPermissions: UserAccessPermissions[] = [];
  uniqueUserNames: string[] = []
  originalDetailAccessPermission: DetailUserAccessPermissions[] = [];
  detailAccessPermission: DetailUserAccessPermissions[] = [];
  originalMenuDetailAccessPermission: DetailUserAccessPermissions[] = [];
  detailMenuAccessPermission: DetailUserAccessPermissions[] = [];
  originalFunctionDetailAccessPermission: DetailUserAccessPermissions[] = [];
  detailFunctionAccessPermission: DetailUserAccessPermissions[] = [];
  originalWebapiDetailAccessPermission: DetailUserAccessPermissions[] = [];
  detailWebapiAccessPermission: DetailUserAccessPermissions[] = [];
  detailActiveButton: number = -1;
  lastSelectedIndex: number = -1;
  recordChanged: boolean = false;

  constructor(private utilityService: UtilityService,
              private securityService: SecurityService,
              private menuService: MenuService) {
  }

  ngOnInit() {
    this.loadingSub = this.menuService.loadingStatusChanged.subscribe((status: boolean) => {
      this.isLoadingStaticData = status;
      // console.log(status);
      // console.log(this.menuService.GetActiveMenuName());
      if (status && this.menuService.GetActiveMenuName()=='Gestione Utenti') {
        // dal momento che e' diventato vero, ricarico i dati
        // this.CaricaDatiStatici().then(r => console.log('gestione utenti, pagina pronta...'));
        this.ResetValues();
        this.CaricaDatiStatici();
      } else {
        // console.log('gestione utenti, caricamento dei dati in pagina...')
        // la visualizzazione dello splash screen e' gestita direttamente nel componente LoadingPageComponent
      }
    });
  }

  ngOnDestroy() {
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
  }

  ResetValues() {
    this.isFirsttime = true;
    this.isDetailVisible = false;
    this.detailActiveButton = -1;
    this.lastSelectedIndex = -1;
    this.recordChanged = false;
  }

  async LoadUserAccessPermissions()
  {
      const token = this.utilityService.GetSecurityToken();
      if(!token || token == '')
      {
        return;
      }

      const result = await this.securityService.GetAllUserAccessPermissions();
      if(result.success)
      {
        this.refreshAllAccessPermission(result.permissionList)
      }
      else {
        // console.error('Error loading user access permissions: ' + result.errorMessage);
      }
  }

  refreshAllAccessPermission(accessPermissions: UserAccessPermissions[] | undefined) {
    this.userAccessPermissions = [];
    if (accessPermissions !== null) {
      this.userAccessPermissions = JSON.parse(JSON.stringify(accessPermissions));
      this.uniqueUserNames = this.userAccessPermissions.map(item => item.email)
        .filter((value, index, self) => self.indexOf(value) === index);
      this.uniqueUserNames.sort((a, b) => a.localeCompare(b));
      this.isFirsttime = false;
    }
  }

  async CaricaDatiStatici() {
    this.isLoadingStaticData = true;

    const loadingPromise = this.loadingStaticData();
    const timeoutPromise = new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, 2000);
    });

    await Promise.all([loadingPromise, timeoutPromise]);

    this.isLoadingStaticData = false;
    this.menuService.StopLoadingInProgressScreen(); // Provochera' un nuovo evento di cambio stato.
  }

  async loadingStaticData() {
    this.LoadUserAccessPermissions();
  }

  RefreshPageData()
  {
    this.menuService.ShowLoadingInProgressScreen(); // Provochera' un nuovo evento di cambio stato.
    this.isDetailVisible = false;
    this.detailActiveButton = -1;
    this.lastSelectedIndex = -1;
    this.recordChanged = false;
  }

  ShowDetails(email: string, index: number) {
    this.detailActiveButton = index;
    this.lastSelectedIndex = index;
    this.isDetailVisible = false;
    this.detailAccessPermission = this.userAccessPermissions.filter(item => item.email === email).map(item => {
      return {
        ...item,
        isRowChanged: false
      };
    });
    this.SetupAccessPermissionsList();
    this.isDetailVisible = true;
  }

  SaveMenuRowChange(item: DetailUserAccessPermissions, i: number) {
    this.securityService.PostChangeUserAccessPermission(item);
    this.originalMenuDetailAccessPermission[i].change = item.change;
    this.originalMenuDetailAccessPermission[i].read = item.read;
    this.originalMenuDetailAccessPermission[i].update = item.update;
    this.originalMenuDetailAccessPermission[i].delete = item.delete;
    item.isRowChanged = false;
    this.recordChanged = true;
  }

  SaveFunctionRowChange(item: DetailUserAccessPermissions, i: number) {
    this.securityService.PostChangeUserAccessPermission(item);
    this.originalFunctionDetailAccessPermission[i].change = item.change;
    this.originalFunctionDetailAccessPermission[i].read = item.read;
    this.originalFunctionDetailAccessPermission[i].update = item.update;
    this.originalFunctionDetailAccessPermission[i].delete = item.delete;
    item.isRowChanged = false;
    this.recordChanged = true;
  }

  SaveWebapiRowChange(item: DetailUserAccessPermissions, i: number) {
    this.securityService.PostChangeUserAccessPermission(item);
    this.originalWebapiDetailAccessPermission[i].change = item.change;
    this.originalWebapiDetailAccessPermission[i].read = item.read;
    this.originalWebapiDetailAccessPermission[i].update = item.update;
    this.originalWebapiDetailAccessPermission[i].delete = item.delete;
    item.isRowChanged = false;
    this.recordChanged = true;
  }

  CheckMenuNeedToBeSaved(i: number): boolean {
    return this.areDifferent(
      this.detailMenuAccessPermission[i],
      this.originalMenuDetailAccessPermission[i]);
  }

  CheckFunctionNeedToBeSaved(i: number): boolean {
    return this.areDifferent(
      this.detailFunctionAccessPermission[i],
      this.originalFunctionDetailAccessPermission[i]);
  }

  CheckWebapiNeedToBeSaved(i: number): boolean {
    return this.areDifferent(
      this.detailWebapiAccessPermission[i],
      this.originalWebapiDetailAccessPermission[i]);
  }

  areDifferent(first: DetailUserAccessPermissions, second: DetailUserAccessPermissions) : boolean {
    return first.change !== second.change
      || first.read     !== second.read
      || first.update   !== second.update
      || first.delete   !== second.delete;
  }

  SetupAccessPermissionsList() {
    this.detailAccessPermission.sort((a, b) => a.functionName.localeCompare(b.functionName));
    this.originalDetailAccessPermission = JSON.parse(JSON.stringify(this.detailAccessPermission));

    this.detailMenuAccessPermission = this.detailAccessPermission.filter(r => r.functionType === FunctionType.menu);
    this.originalMenuDetailAccessPermission = this.originalDetailAccessPermission.filter(r => r.functionType === FunctionType.menu);
    this.detailFunctionAccessPermission = this.detailAccessPermission.filter(r => r.functionType === FunctionType.function);
    this.originalFunctionDetailAccessPermission = this.originalDetailAccessPermission.filter(r => r.functionType === FunctionType.function);
    this.detailWebapiAccessPermission = this.detailAccessPermission.filter(r => r.functionType === FunctionType.webapi);
    this.originalWebapiDetailAccessPermission = this.originalDetailAccessPermission.filter(r => r.functionType === FunctionType.webapi);
  }

  masterToggle<T extends BooleanKeys<DetailUserAccessPermissions>>(
    event: MatCheckboxChange,
    permissions: DetailUserAccessPermissions[],
    checker: (i: number) => boolean,
    prop: T) {
    permissions.forEach((row, i) => {
      row[prop] = event.checked;
      row.isRowChanged = checker(i);
    });
  }

  areSomeSelected<T extends BooleanKeys<DetailUserAccessPermissions>>(
    permissions: DetailUserAccessPermissions[], prop: T) {
    return permissions.filter(p => p[prop]).length > 0;
  }

  areAllSelected<T extends BooleanKeys<DetailUserAccessPermissions>>(
    permissions: DetailUserAccessPermissions[], prop: T) {
    const numSelected = permissions.filter(p => p[prop]).length;
    const numRows = permissions.length;
    return numSelected === numRows;
  }
}

type BooleanKeys<T> = {
  [K in keyof T]: T[K] extends boolean ? K : never
}[keyof T];